module.exports = __webpack_public_path__ + "assets/img/27_1432.5f8dfb8b.jpg";